import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';


import { connect } from 'react-redux'
import { translate } from "react-translate";
import { Link } from 'react-router-dom'

import {
    Segment,
    Grid,
    Image,
    Header,
    Icon,
    Modal,
    Button,
    Item
} from 'semantic-ui-react'
import './protectedAcceuilComponent.css'

import AddList from '../Listes/AddList';

import icon_home_yaya from '../../../assets/svg/icon_home_yaya.svg';
import TravauxNew from '../../../assets/svg/TravauxNew.svg';
import Murs from '../../../assets/svg/Murs.svg';
import Parquet from '../../../assets/svg/Parquet.svg';
import Cloture from '../../../assets/svg/Cloture.svg';
import ListesNew from '../../../assets/svg/ListesNew.svg';
import creerList from '../../../assets/icons/creerList.png';
import ListoComponent from '../Listes/ListoComponent';
import { addList } from '../../../redux/actions/ConfigFileAction';

import Exit from '../../../assets/svg/Exit.svg';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app
})

class ConnectedProtectedAcceuilComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            configFile: null,
        }

        this.closeModal = this.closeModal.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentWillMount() {
        var self = this;
        var envData = {
            status: this.state.status,
            lang: this.props.app.lang
        };
        API.getEnv(this.props.app.token, envData).then((res) => {
            API.getConfigFile(res.data.link).then((configFileResponse) => {
                self.setState({
                    configFile: configFileResponse.data
                });
                setTimeout(() => {
                    this.forceUpdate();
                }, 10);
            })
        });
    }

    closeModal() {
        this.setState({
            modal: false
        })
    }

    handleClick(e) {
        e.preventDefault();
        this.setState({
            modal: true
        })
    }

    render() {

        let text = [
            '<i aria-hidden="true" class="long arrow left icon"></i>',
            '<i aria-hidden="true" class="long arrow right icon"></i>'
        ]

        const owl = {
            0: {
                items: 1,
                loop: true
            },
            800: {
                items: 3,
                loop: true
            },
            1200: {
                items: 5,
                loop: true
            }
        }


        const { t } = this.props;

        let reloadConfigFile = true
        let carou = []

        if (this.state.configFile) {
            // Checking if lang has changed 
            Object.entries(this.state.configFile.Changes).map((key, Mainindex) => {
                if (this.props.app.lang == key[0]) {
                    reloadConfigFile = false;
                }
            })
            // If lang has changed, then we reset the component
            if (reloadConfigFile) {
                this.componentWillMount()
            }

            Object.entries(this.state.configFile).map((key, Mainindex) => {
                let objet = {};
                if (key[0] === "ListWorks") {
                    Object.entries(key[1]).map((key, MainindexFirst) => {
                        objet.image = key[1].Icon.slice(0, -3) + "svg"
                        objet.id = key[1].WorkId
                        objet.name = key[1].Work[this.props.app.lang]
                        carou[MainindexFirst] = objet

                        objet = {};
                    })
                }
            })
        }
        

        return (

            <Grid stackable id="accueilSection">

                <Grid.Row id="headerSection">
                    <Grid.Column width={6}>
                        <Segment basic>
                            <Item.Image size='mini' src={icon_home_yaya} id="imageSection" />
                            <Item.Content verticalAlign='middle'>
                                <Item.Header as='h3' id="titleSection">{t("Item1_title")}</Item.Header>
                            </Item.Content>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={6}>
                        <Segment basic>
                            <Item.Group>
                                <Item>
                                    <Item.Image size='mini' src={TravauxNew} />
                                    <Item.Content verticalAlign='middle'>
                                        <Item.Header as='h3' id="titleSubSection">{("Travaux")}</Item.Header>
                                    </Item.Content>
                                </Item>
                            </Item.Group>
                        </Segment>

                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column>
                        <Segment raised style={{ borderRadius: '10px', marginBottom: '20px' }} id="accueilWorkCarousel">

                        <OwlCarousel
                            className="owl-theme"
                            margin={10}
                            items={5}
                            dots={false}
                            nav
                            navText={text}
                            responsive={owl}
                        >
                            {
                                carou.map((x, i) => {
                                    return (
                                        <div key={i} className="item">
                                            <Link to={'/works/' + x.id} >
                                              <div className="single-testimonial">
                                                  <div className="work-carousel-wrapper">
                                                      <div className="work-carousel-img">
                                                          <Image
                                                          centered
                                                          src={API.resourceURL + '/upload/iconsworks/' + x.image}/>
                                                      </div>
                                                      <div>
                                                          <div className="iconTravauxTitleAccueil">
                                                            <h4>{x.name}</h4>
                                                          </div>
                                                      </div>
                                                  </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })
                            }
                          </OwlCarousel>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column mobile={8} tablet={8} computer={6}>
                        <Segment basic>
                            <Item.Group>
                                <Item>
                                    <Item.Image size='mini' src={ListesNew} />
                                    <Item.Content verticalAlign='middle'>
                                        <Item.Header as='h3' id="titleSubSection">{t("Item3_title")}</Item.Header>
                                    </Item.Content>
                                </Item>
                            </Item.Group>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column verticalAlign='middle' textAlign='center' mobile={8} tablet={8} computer={10}>
                        <Modal open={this.state.modal} onClose={this.closeModal} size='tiny' trigger={
                            <Grid.Column>
                                <Button
                                    circular
                                    onClick={this.handleClick}
                                    size='small'
                                    floated='right'
                                    id="smallBtn">
                                    <Icon name='plus circle' /> {t('Header1_title')}
                                </Button>
                            </Grid.Column>
                        } >
                            <Modal.Header id="modalHeader">
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column textAlign='center'>
                                            <Image onClick={this.closeModal} src={Exit} floated='right' id="modalExit" />
                                            <Header as='h2' id="modalTitle" verticalAlign='center' textAlign='center'>Creer une liste</Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Modal.Header>
                            <Modal.Content >
                                <AddList close={this.closeModal} />
                            </Modal.Content>
                        </Modal>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <ListoComponent />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

const ProtectedAcceuilComponent = connect(mapStateToProps)(ConnectedProtectedAcceuilComponent);
export default translate("ProtectedAccueilComponent")(ProtectedAcceuilComponent)



// WEBPACK FOOTER //
// ./src/components/Protected/Acceuil/ProtectedAcceuilComponent.js